module.exports = __webpack_public_path__ + "img/banner_inversionista.c1c366a3.webp";